import { StoreHour } from '@adapters/prismic/fetching/stores/types';

export const getTodaysHours = (today: StoreHour, t: any) => {
  if (
    !today?.open ||
    !today?.close ||
    today.close.toLowerCase().includes('close') ||
    today.open.toLowerCase().includes('close') ||
    today.close.toLowerCase().includes('ferm') ||
    today.open.toLowerCase().includes('ferm')
  ) {
    if (today?.name) {
      return t('common:closed.today.reason', { reason: today.name });
    }
    return t('common:closed.today');
  }
  return t('common:stores.openToday', {
    open: today?.open,
    close: today?.close,
  });
};
